// Country IDs
import { ProvinceIdEnum } from '../models/enum/shared/province-id-enum';
import { AccountTypeIdEnum } from '../models/transactions/enum/account-type-id.enum';

export const SPP_SUPPORT_PHONE_NUMBER = '1-888-293-1839';

export const CANADA_COUNTRY_ID = 1;
export const USA_COUNTRY_ID = 2;
export const UK_COUNTRY_ID = 236;

export const CANADA_COUNTRY_CODE = 'CA';

export const AGE_OF_MAJORITY_BY_PROVINCE_ID: Record<ProvinceIdEnum, number> = {
  [ProvinceIdEnum.Alberta]: 18,
  [ProvinceIdEnum.Manitoba]: 18,
  [ProvinceIdEnum.Ontario]: 18,
  [ProvinceIdEnum.PEI]: 18,
  [ProvinceIdEnum.Quebec]: 18,
  [ProvinceIdEnum.Saskatchewan]: 18,
  [ProvinceIdEnum.BC]: 19,
  [ProvinceIdEnum.NewBrunswick]: 19,
  [ProvinceIdEnum.Newfoundland]: 19,
  [ProvinceIdEnum.NovaScotia]: 19,
  [ProvinceIdEnum.NorthwestTerritories]: 19,
  [ProvinceIdEnum.Nunavit]: 19,
  [ProvinceIdEnum.Yukon]: 19
};

// Account Type Labels
export const AccountTypeLabels: Record<AccountTypeIdEnum, string> = {
  [AccountTypeIdEnum.ContributionAccount]: $localize`Contribution`,
  [AccountTypeIdEnum.VariableBenefitAccount]: $localize`Variable Benefit`,
  [AccountTypeIdEnum.AnnuityPensionAccount]: $localize`Annuity Pension`,
  [AccountTypeIdEnum.VPLAPensionAccount]: $localize`VPLA Pension`,
  [AccountTypeIdEnum.MemberClearingAccount]: $localize`Member Clearing`,
  [AccountTypeIdEnum.EmployerClearingAccount]: $localize`Employer Clearing`,
  [AccountTypeIdEnum.SPPRemittances]: $localize`SPP Remittance`,
  [AccountTypeIdEnum.SPPSettlement]: $localize`SPP Settlement`,
  [AccountTypeIdEnum.SPPAccountAdjustments]: $localize`SPP Account Adjustment`,
  [AccountTypeIdEnum.SPPTransfers]: $localize`SPP Transfer`,
  [AccountTypeIdEnum.TransferInAccount]: $localize`Transfer-In`
};

// Links

export const SPP_NEW_MEMBER_TEMPLATE_LINK =
  'https://gvpensionplan-public-files.s3.ca-central-1.amazonaws.com/new_member_template.csv';
